import * as qrCodeManageView from '../services/qrCodeManageView';

export default {
  namespace: 'qrCodeManageView',

  state: {
    searchFormData: null,
    tab: 0,
    tableList: null,
    total: 0,
    hasNext: false,
    groupList: null,
    qrParamsFormData: [{ startDateTime: '', endDateTime: '', qrcodeTitle: '' }],
    refreshQrParamsFormData: 0,
  },

  effects: {
    // 二维码信息数据页查询
    *qrcodeDataPage({ payload: { values }, callback }, { put, call }) {
      const response = yield call(qrCodeManageView.qrcodeDataPage, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname === '/system/qr_code_manage/view') {
          dispatch({
            type: 'save',
            payload: {
              groupList: null,
              qrParamsFormData: [
                { startDateTime: '', endDateTime: '', qrcodeTitle: '' },
              ],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: 0,
            },
          });
        }
      });
    },
  },
};
